export default __webpack_public_path__ + "assets/media/check_mark.6ab9e724.png";